(() => {
  if (customElements.get('ffn-world-explorer')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  class WorldExplorer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-world-tab]')];
      this.panels = [...this.querySelectorAll('[data-world-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        });
      });
      this.querySelectorAll('[data-world-open-pack]').forEach(link => link.addEventListener('click', event => {
        const detail = document.getElementById(link.hash.slice(1));
        const button = detail?.parentElement.querySelector('.ffn-pack-button');
        if (!detail || !button) return;
        event.preventDefault();
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
        requestAnimationFrame(() => {
          detail.closest('.ffn-world-pack').scrollIntoView({behavior: reduce.matches ? 'instant' : 'smooth', block:'start'});
          button.focus({preventScroll:true});
        });
      }));
    }
    select(index) {
      if (this.tabs[index].getAttribute('aria-selected') === 'true') return;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        this.panels[i].hidden = !active; this.panels[i].inert = !active;
      });
      if (!reduce.matches) {
        this.panels[index].animate([{opacity:.4,transform:'translateY(9px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
      window.ffnGraphicThread?.refresh();
      dispatchEvent(new Event('scroll'));
    }
  }
  customElements.define('ffn-world-explorer', WorldExplorer);
  function init() {
    const root = document.querySelector('.ffn-world-experience');
    if (!root || root.dataset.worldReady) return;
    root.dataset.worldReady = 'true';
    const scenes = [...root.querySelectorAll('[data-world-depth]')];
    const visible = new Set(); let frame = 0;
    const paint = () => {
      frame = 0;
      if (document.hidden) return;
      visible.forEach(scene => {
        if (scene.closest('[hidden]')) return;
        const r = scene.getBoundingClientRect();
        const progress = Math.max(-1,Math.min(1,(innerHeight/2-r.top-r.height/2)/innerHeight));
        scene.style.setProperty('--world-drift', reduce.matches ? '0px' : `${progress * (innerWidth < 761 ? 32 : 64)}px`);
      });
    };
    const schedule = () => {if (!frame) frame = requestAnimationFrame(paint);};
    const observer = new IntersectionObserver(entries => {entries.forEach(e => {
      if(e.isIntersecting) {
        visible.add(e.target);
        if(!e.target.dataset.entered && !reduce.matches) {
          e.target.dataset.entered='true';
          const copy=e.target.closest('.ffn-world-scene')?.querySelector('.ffn-world-scene__copy');
          if(copy) [...copy.children].filter(el=>!el.classList.contains('ffn-world-scene__signature')).forEach((el,i)=>el.animate([{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,delay:i*70,easing:'cubic-bezier(.2,.7,.2,1)',fill:'backwards'}));
        }
      } else visible.delete(e.target);
    });schedule();},{rootMargin:'40px'});
    scenes.forEach(scene => observer.observe(scene));
    addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});reduce.addEventListener('change',schedule);
    const links = [...root.querySelectorAll('.ffn-world-chapters a')];
    const chapters = links.map(a=>document.querySelector(a.hash));
    let navFrame = 0;
    const updateNav = () => {
      navFrame = 0; let active=0;
      chapters.forEach((el,i)=>{if(el?.getBoundingClientRect().top<innerHeight*.4)active=i;});
      links.forEach((a,i)=>{if(i===active){if(!a.hasAttribute('aria-current'))a.setAttribute('aria-current','location');}else if(a.hasAttribute('aria-current'))a.removeAttribute('aria-current');});
    };
    addEventListener('scroll',()=>{if(!navFrame)navFrame=requestAnimationFrame(updateNav);},{passive:true});
    updateNav();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
